import { useState } from 'react'
import ContactInForm from '../partialComponents/ContactInFormHeader'
import {
    validateEmail,
    validatePhoneNumber,
    validateTexts,
    validateNumber
} from '../utils/validations'
import { DB, getTimeStamp } from '../../firebase'
import ErrorStatus from '../partialComponents/ErrorStatus'
import ContactInFormHeader from '../partialComponents/ContactInFormHeader'
import { Redirect } from 'react-router-dom'
import {saveLead} from '../api/leads'
import axios from 'axios';

export default function HeaderForm({cutprice,currentprice,customTitle }) {
    console.log(cutprice, currentprice);
    const [formValues, setFormValues] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        program: '',
        subProgram: '',
        syllabus:'',
        subjects:'',
        grade:'',
        countryCode:''
    })
    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')
    const [loading, setLoading] = useState('')
    const [requestingClass, setrequestingClass] = useState(false)
    const [stDetailStatus, setStDetailStatus] = useState(false)
    // GOTO next page

    const [bookedClass, setbookedClass] = useState(false)
    // goto success page

    const msgTypes = {
        error: 'error',
        success: 'success',
        waiting: 'waiting'
    }

    function generateMsg(type, msg) {
        setError(type === msgTypes.error ? msg : '')
        setLoading(type === msgTypes.waiting ? msg : '')
        setSuccess(type === msgTypes.success ? msg : '')
    }

    function handleChange(e) {
        setFormValues((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    function handleNext() {
        generateMsg(msgTypes.error, '')

        if (!validateTexts(formValues.name)) {
            generateMsg(msgTypes.error, 'Please Enter Name')
            return
        } else {
            if (!validateEmail(formValues.email)) {
                generateMsg(msgTypes.error, 'Invalid Email')
                return
            } else {
                if (!validatePhoneNumber(formValues.phoneNumber)) {
                    generateMsg(
                        msgTypes.error,
                        'Enter a 10 digit valid phone no.'
                    )
                    return
                } else {
                    setStDetailStatus(true)
                }
            }
        }
    }

    function handleBookClass() {
        generateMsg(msgTypes.error, '')
        setrequestingClass(true)

        if (!validateTexts(formValues.name)) {
            generateMsg(msgTypes.error, 'Please Enter Name')
            return
        }
        if (!validateEmail(formValues.email)) {
            generateMsg(msgTypes.error, 'Invalid Email')
            return
        }
        if (!validatePhoneNumber(formValues.phoneNumber)) {
            generateMsg(
                msgTypes.error,
                'Enter a 10 digit valid phone no.'
            )
            return
        }
        if (!validateNumber(formValues.grade)) {
            generateMsg(
                msgTypes.error,
                'Enter A Valid Grade'
            )
            return
        }
        if (!validateTexts(formValues.syllabus)) {
            generateMsg(
                msgTypes.error,
                'Enter A Valid Syllabus'
            )
            return
        }
        if (!validateTexts(formValues.subjects)) {
            generateMsg(
                msgTypes.error,
                'Enter A Valid Subject'
            )
            return
        }
        if (!validateTexts(formValues.countryCode)) {
            generateMsg(
                msgTypes.error,
                'Enter A Valid Country Code'
            )
            return
        }
        generateMsg(msgTypes.waiting, 'Requesting...')
        DB.collection('leads')
        .add({
            name: formValues.name,
            email: formValues.email,
            phoneNumber: (formValues.countryCode?formValues.countryCode:'')+formValues.phoneNumber,
            program: formValues.program,
            subProgram: formValues.subProgram,
            timestamp: getTimeStamp(),
            rejected: false,
            completed: false,
            confirmed: false,
            syllabus:formValues.syllabus,
            subjects:formValues.subjects,
            grade:formValues.grade
        })
        .then(() => {
            generateMsg(
                msgTypes.success,
                'Booked SuccessFully'
            )
            setbookedClass(true)
            setrequestingClass(false)
            saveLead({
                name: formValues.name,
                email: formValues.email,
                phoneNumber: (formValues.countryCode?formValues.countryCode:'')+formValues.phoneNumber,
                program: formValues.program,
                subProgram: formValues.subProgram,
                timestamp: getTimeStamp(),
                rejected: false,
                completed: false,
                confirmed: false,
                syllabus:formValues.syllabus,
                subjects:formValues.subjects,
                grade:formValues.grade
            })
        })
        .catch(() => {
            generateMsg(msgTypes.error, 'Error Occured')
            setrequestingClass(false)
        })
    }
    return (
            <div className="form_page_wrapper" style={{width:'100%'}}>
                <div className="form_card headercontactform">
                    {(!bookedClass && (
                        <>
                            <h1 className="font-Quick font-bold">
                                {customTitle ? (
                                    <div className='header-pricing'>
                                        <div>{customTitle}</div>
                                    </div>
                                ) : (
                                    <div className='header-pricing'>
                                        <div>Starting at</div> <s><h4 style={{color:'red',marginLeft:'10px',marginRight:'10px'}}>Rs.{cutprice}</h4></s> <div><h4>Rs.{currentprice}/Subject</h4></div>
                                    </div>
                                )}
                            </h1>

                            <ErrorStatus
                                error={error}
                                success={success}
                                loading={loading}
                            />
                            <ContactInFormHeader
                                handleChange={handleChange}
                                handleNext={handleNext}
                                formValues={formValues}
                                handleBookClass={handleBookClass}
                                requestingClass={requestingClass}
                                page1={!stDetailStatus}
                            />
                        </>
                    )) || <Redirect to="/thankyou" />}
                </div>
            </div>
    )
}
